import { render, staticRenderFns } from "./CopyWorkModal.vue?vue&type=template&id=d982fedc&"
import script from "./CopyWorkModal.vue?vue&type=script&lang=js&"
export * from "./CopyWorkModal.vue?vue&type=script&lang=js&"
import style0 from "./CopyWorkModal.vue?vue&type=style&index=0&id=d982fedc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports